export default "__VITE_ASSET__18b2131b__"